import { gql } from "@apollo/client";

export const GET_ORDER_IDFA_REPORT = gql`
  query getOrderIdfaReport($orderType: OrderType!, $orderId: Int!) {
    getOrderIdfaReport(orderType: $orderType, orderId: $orderId) {
      orderType
      orderId
      hashId
      country
      timezone
      total
      uniqueIdfas
      rows {
        id
        idfa
        completedAt
        keyword
      }
      files {
        id
        fileName
        sourcePath
        contractorTaskId
        country
        rowsCount
        createdAt
      }
    }
  }
`;

export const GET_IDFA_REPORT_ORDERS = gql`
  query getIdfaReportOrders {
    getIdfaReportOrders {
      orderType
      orderId
      hashId
      appTitle
      storeAppId
      country
      userEmail
      timezone
      files
      rows
      firstCompletedAt
      lastCompletedAt
      lastImportedAt
    }
  }
`;

export const DELETE_IDFA_REPORT_FILE = gql`
  mutation deleteIdfaReportFile($fileId: Int!) {
    deleteIdfaReportFile(fileId: $fileId)
  }
`;
